import {
  Button,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { Image } from '~components/Image/Image';
import { Modal } from '~components/Modal/Modal';
import { ModalMods } from '~components/Modal/Modal.types';
import { PreloaderOverlay } from '~components/PreloaderOverlay/PreloaderOverlay';

import styles from './PopupForm.module.scss';
import { PopupFormProps } from './PopupForm.types';

export const PopupForm = ({
  success,
  error,
  children,
  onClose,
  active,
  isLoading,
  title,
  text,
  logo,
}: PopupFormProps) => {
  function handleClose() {
    document.body.style.overflow = '';
    onClose();
  }

  return (
    <>
      <Modal active={active} onClose={handleClose} mods={[ModalMods.Xs]}>
        {title && (
          <div className={styles.head}>
            {logo && (
              <div className={styles.logo}>
                <Image className={styles.logoImg} {...logo} />
              </div>
            )}
            <Typography
              tagName={TypographySizes.h4}
              mods={[TypographyMods.titleL]}
              className={styles.title}
            >
              {success?.title || title}
            </Typography>
          </div>
        )}
        <div className={styles.body}>
          {success || error ? (
            <>
              <div
                className={classNames({
                  [styles.successMessage]: success,
                  [styles.errorMessage]: error,
                })}
                data-testid="popupStatusMessage"
              >
                {success?.message || error?.message}
              </div>
              <Button
                mod="primary"
                onClick={handleClose}
                className={styles.successButton}
              >
                Закрыть
              </Button>
            </>
          ) : (
            children
          )}
        </div>
        {text && <div className={styles.footer}>{text}</div>}
      </Modal>
      {isLoading && <PreloaderOverlay active={isLoading} />}
    </>
  );
};
